"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    "Prefer not to say",
    "Afro Caribbean",
    "Arab",
    "Bangladeshi",
    "Black African",
    "Black Caribbean",
    "Chinese",
    "Indian",
    "Other",
    "Other Asian",
    "Other black background",
    "Other mixed background",
    "Other white background",
    "Pakistani",
    "White",
    "White and Asian",
    "White and black African",
    "White and black Caribbean",
    "White British",
    "White English",
    "White European",
    "White Irish",
    "White Scottish",
    "White Welsh",
];
